import React from 'react'
import { Card, mq } from 'plume-ui'
import { css } from '@emotion/react'

type Props = {
  'data-test-id'?: string
  children: React.ReactNode
}

export const DoubleColumnContent: React.FC<Props> = (props) => {
  return (
    <Card.Content
      data-test-id={props['data-test-id']}
      css={css`
        padding: 15px 25px !important;
        display: flex;
        flex-direction: column;
        ${mq.large} {
          flex-direction: row;
          > dl {
            width: 50%;
            &:last-of-type {
              padding-left: 1rem;
            }
          }
        }
      `}
    >
      {props.children}
    </Card.Content>
  )
}
